import { subject } from '@casl/ability'

import { BTN_TXT } from 'constants/txt'
import { Button, BUTTON_TYPES } from 'components/Button'
import { Can, ACTIONS, SUBJECTS } from 'features/Permission'
import { useRFPDetailsContext } from 'features/RFP/RFPDetails/Providers/RFPDetailsContextProvider'
import { useRFPDetailsPopupContext } from '../../RFPDetails/Providers/RFPDetailsPopupProvider'

export const OpenSurveyButton = () => {
  const { submitSurveyPopup } = useRFPDetailsPopupContext()
  const rfpDetailsContext = useRFPDetailsContext()

  const { data } = rfpDetailsContext.state

  return (
    <Can I={ACTIONS.VOTE} a={subject(SUBJECTS.SURVEY, { ...data })}>
      <Button
        type={BUTTON_TYPES.PRIMARY}
        onClick={() => submitSurveyPopup.actions.open()}
        upperCase
      >
        {BTN_TXT.OPEN_SURVEY}
      </Button>
    </Can>
  )
}
